import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { Store } from '@ngrx/store';
import OFFERS_ACTIONS from '../../store/offers/offers.actions';
import { OffersType } from '@toevla-webapplications/core';

@Component({
	selector: 'ivva-type-selector',
	standalone: true,
	templateUrl: './type-selector.component.html',
	styleUrls: ['./type-selector.component.scss'],
})
export class TypeSelectorComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);
	private readonly router = inject(Router);
	private readonly store = inject(Store);

	ngOnInit() {
		this.route.paramMap.pipe(take(1)).subscribe((params) => {
			const type = params.get('type');

			if (type) {
				this.setType(type.toLowerCase());
			} else {
				this.redirectToHome();
			}
		});
	}

	private setType(type: string) {
		switch (type) {
			case 'daguitstap':
				this.store.next(OFFERS_ACTIONS.setType({ t: OffersType.DAYTRIP }));
				this.redirectToHome();
				break;
			case 'vakantieverblijf':
				this.store.next(OFFERS_ACTIONS.setType({ t: OffersType.ACCOMMODATION }));
				this.redirectToHome();
				break;
			case 'georganiseerde-vakantie':
			case 'georganiseerdevakantie':
				this.store.next(OFFERS_ACTIONS.setType({ t: OffersType.ORGANIZED_HOLIDAY }));
				this.redirectToHome();
				break;
		}
	}

	private redirectToHome() {
		this.router.navigate(['/']);
	}
}
